import type { PublicUser } from "@scenix/core";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { AccountMenu } from "./AccountMenu";
import { CommandPalette } from "./CommandPalette";
import { Logo } from "./Logo";
import { SpaceBadge } from "./SpaceBadge";

export function AppShell({ user, children }: { user: PublicUser; children: ReactNode }) {
  return (
    <div className="shell">
      <header className="shell__bar">
        <div className="shell__left">
          <Link to="/spaces" className="shell__mark" aria-label="scenix">
            <Logo />
          </Link>
          <SpaceBadge />
        </div>

        <div className="shell__account">
          {/* Says the shortcut exists. A palette nobody knows about is a
              palette nobody uses. */}
          <SearchHint />
          <AccountMenu user={user} />
        </div>
      </header>

      <main className="shell__main">{children}</main>
      <CommandPalette />
    </div>
  );
}

/** Opens the palette, and more importantly advertises the key. */
function SearchHint() {
  const mac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

  return (
    <button
      type="button"
      className="shell__search"
      onClick={() =>
        document.dispatchEvent(
          new KeyboardEvent("keydown", { key: "k", metaKey: true, bubbles: true }),
        )
      }
    >
      <span>Search</span>
      <kbd>{mac ? "\u2318" : "Ctrl"}K</kbd>
    </button>
  );
}
